// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".working-hours[data-v-32f0adf6]{margin-top:24px}.working-hours-info[data-v-32f0adf6]{font-style:normal;font-weight:400;font-size:14px;line-height:20px;color:var(--q4s-neutral-500)}.list-enter[data-v-32f0adf6],.list-leave-to[data-v-32f0adf6]{transform:translateX(30px)}.list-enter-active[data-v-32f0adf6]{transition:all .2s linear}.list-leave-active[data-v-32f0adf6]{transition:all .1s linear}", ""]);
// Exports
module.exports = exports;
